import { Box, Button, Modal, ModalProps, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { AttachmentIcon } from '../../../icons';
import { ExtAttachmentType } from '../../../api/extForms';

export type FilesModalProps = ModalProps & {
  offerFiles: ExtAttachmentType[];
  onBack: () => void;
  onApprove: () => void;
};

/**
 * FilesModal component
 * @private
 *
 * @param onBack
 * @param onApprove
 * @param offerFiles
 * @param modalProps
 */
export const FilesModal: React.FC<FilesModalProps> = ({
  onBack,
  onApprove,
  offerFiles = [],
  ...modalProps
}) => {
  const { t } = useTranslation('forms');

  return (
    <Modal title={t('optionalFilesModal.title')} {...modalProps}>
      <Stack>
        <Text fz="md" fw={400}>
          {t('optionalFilesModal.description')}
        </Text>
        {offerFiles.map(file => (
          <Box
            key={file.uuid}
            sx={{ display: 'flex', gap: 8, alignItems: 'center' }}
          >
            <AttachmentIcon />
            <Text fz="md" fw={600}>
              {file.name}
            </Text>
          </Box>
        ))}
        <Text fz="md" fw={400}>
          {t('optionalFilesModal.question')}
        </Text>
      </Stack>
      <Box mt={24} sx={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <Button variant="default" onClick={onBack}>
          {t('optionalFilesModal.back')}
        </Button>
        <Button onClick={onApprove}>{t('optionalFilesModal.approve')}</Button>
      </Box>
    </Modal>
  );
};
